import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { commissionsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUniqueRevenueSourceNameMutation = ({ name, setError }) => {
	const dispatch = useDispatch();

	return useMutation(
		name => commissionsService.isUniqueRevenueSourceName(name),
		{
			onMutate() {
				dispatch(uiActions.showSpinnerOverlay());
			},
			onError: (error: ErrorResponse) => {
				setError(name, {
					type: "manual",
					message: "Name already exists",
				}); //Todo change when backend is ready
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useUniqueRevenueSourceNameMutation;
